'use strict';

module.exports = require('./index').default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/schema-utils/dist/cjs.js
// module id = PmJp
// module chunks = 11